module.exports = __webpack_public_path__ + "static/media/SelfAwarenessOfValuesGREEK.fd73051a.vtt";